import React from "react";
import { Route, Routes } from "react-router-dom";
import { ManagerPasswordList } from "./containers";

export const ManagerPassword = () => {
    return (
        <>
            <Routes>
                <Route path="/" element={<ManagerPasswordList />} />
            </Routes>
        </>
    );
};
